<template lang="pug">
v-aside.sidebar(ref="userSidebar",
  placement="right",
  :header="userData.displayName",
  :show="isShowUserSidebar",
  :width="offCanvasWidth")
  .row
    .col-xs-12.mobile-menu
      ul.style-none.mobile-user-menu--hunter(v-if="isLogin")
        router-link.pink.pointer(tag="li",
          v-if="isManiplatorLogin",
          :to="{ name: 'companyCareerList' }",
          @click.native="close") {{ $t('header.vacancies') }}
        router-link.pink.pointer(tag="li",
          v-if="isManiplatorLogin",
          :to="{ name: 'companyResumeList' }",
          @click.native="close") {{ $t('header.resumes') }}
        router-link.pink.pointer(tag="li",
          v-if="!isManiplatorLogin",
          :to="{ name: 'userResumeHistory', params: { alias: getUserData.alias } }",
          @click.native="close") {{ $t('header.recruitHistory') }}
        router-link.pink.pointer(tag="li",
          v-if="!isManiplatorLogin",
          :to="{ name: 'userInternsSave', params: { alias: getUserData.alias } }",
          @click.native="close") {{ $t('header.savedVacancies') }}
        router-link.pink.pointer(tag="li",
          v-if="!isManiplatorLogin",
          :to="{ name: 'userResumeList', params: { alias: getUserData.alias } }",
          @click.native="close") {{ $t('header.manageResumes') }}
      ul.style-none.mobile-user-menu--other(v-if="isLogin")
        router-link.pointer(tag="li",
          :to="{ name: 'companyProfile' }",
          @click.native="close",
          v-if="isManiplatorLogin") {{ $t('header.companyImformation') }}
        router-link.pointer(tag="li",
          :to="{ name: 'userProfiles', params: { alias: getUserData.alias } }",
          @click.native="close",
          v-else) {{ $t('header.userSettings') }}
        router-link.pointer(tag="li",
          :to="{ name: 'companySettings' }",
          @click.native="close",
          v-if="isManiplatorLogin") {{ $t('header.accountSettings') }}
        router-link.pointer(tag="li",
          :to="{ name: 'userSettings', params: { alias: getUserData.alias } }",
          @click.native="close",
          v-else) {{ $t('header.accountSettings') }}
        router-link.pointer(tag="li",
          :to="{ name: 'homepage' }",
          @click.native="doLogout()") {{ $t('header.doLogout') }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { aside, accordion } from 'vue-strap'

const offCanvasWidth = 320

export default {
  components: {
    vAside: aside,
    accordion: accordion
  },
  computed: {
    isLogin () {
      return this.getToken !== '' && typeof this.getToken !== 'undefined' && this.getUserData.id !== ''
    },
    isManiplatorLogin () {
      return this.getToken !== '' && typeof this.getToken !== 'undefined' && this.getUserData.id !== '' && this.getUserData.manipulator === true
    },
    ...mapGetters({
      getUserData: 'users/getUserData',
      getToken: 'users/getToken',
      isShowMenuSidebar: 'utilities/isShowMenuSidebar',
      isShowUserSidebar: 'utilities/isShowUserSidebar'
    })
  },
  methods: {
    close () {
      this.toggleUserSidebar(false)
    },
    doLogout () {
      this.logout().then(() => {
        this.toggleUserSidebar(false)
        this.$router.push({ name: 'homepage' })
      })
    },
    ...mapActions({
      logout: 'users/logout',
      toggleUserSidebar: 'utilities/toggleUserSidebar'
    })
  },
  data () {
    let locale = 'tw'
    if (typeof this.$route.params !== 'undefined' &&
      typeof this.$route.params.locale !== 'undefined') {
      locale = this.$route.params.locale
    }

    return {
      locale: locale,
      userData: {},
      offCanvas: window.innerWidth <= 991,
      offCanvasWidth: offCanvasWidth
    }
  },
  created () {
    if (typeof this.getUserData !== 'undefined' &&
      this.getToken !== '' &&
      typeof this.getToken !== 'undefined'
    ) {
      this.userData = JSON.parse(JSON.stringify(this.getUserData))
    }
  },
  mounted () {
    this.$refs.userSidebar.$on('close', () => {
      this.toggleUserSidebar(false)
    })
  }
}
</script>

<style lang="sass" scoped>
@import "~globalStyles/variables"
.sidebar
  background-color: #333333
  color: white
  font-size: 16px
  .mobile-menu
    ul.mobile-user-menu--hunter
      li
        padding-top: 2rem
    ul.mobile-user-menu--other
      margin-top: calc(50vh - 91px)
      margin-bottom: 2rem
  .pointer
    cursor: pointer
</style>



// WEBPACK FOOTER //
// src/components/userOffcanvas.vue